<template>
  <OModal style="justify-content: flex-start">
    <div class="modal__content relative bg-body-primary h-full flex flex-col w-full">
      <OButton
        v-if="false"
        pure
        class="u-center top-16 pr-4 pl-1 absolute text-white z-2 rounded-full"
        :class="{ 'left-5 ': game.orientation === 'vertical', 'right-5 rotate-90': game.orientation === 'horizontal' }"
        style="background: rgba(51, 51, 51, 0.75)"
        @click="$emit('closeModal')"
      >
        <OIcon icon="left-white" class="-m-[3px] w-[30px] h-[30px] u-center" svg-style="fill: #fff" />
        <p class="text-md font-normal">{{ $t('profile.back') }}</p>
      </OButton>
      <div class="game-wrapper2 h-full">
        <iframe
          id="game-container"
          :src="src"
          style="overflow: hidden; height: 100%; width: 100%"
          height="100%"
          width="100%"
          scrolling="none"
          frameborder="0"
          allowfullscreen="allowfullscreen"
        ></iframe>
      </div>
    </div>
  </OModal>
</template>

<script>
import { defineComponent, onMounted } from '@nuxtjs/composition-api';
import { OModal, OModalCloseButton, OButton, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  props: {
    game: {
      type: Object,
      required: true,
    },
    src: {
      type: String,
      required: true,
    },
  },
  components: { OModal, OModalCloseButton, OButton, OIcon },
  setup(props) {
    onMounted(() => {
      if (props.game.orientation === 'horizontal') {
        const gameContainer = document.getElementsByClassName('game-wrapper2')[0];
        gameContainer.classList.add('rotate-90');
        gameContainer.classList.add('origin-top-left');
        gameContainer.classList.add('fixed', 'top-0', 'right-0', 'bottom-0', 'left-full');
        gameContainer.style.height = '100dvw';
        gameContainer.style.width = '100dvh';
      }
    });
  },
});
</script>
